let prefix = '/api/sap/warehouses';
function getWarehouses() {
    return window.axios.get(prefix+'/index')
}
export default {
    getWarehouses
}